import * as React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import { TrendingUp, TrendingDown } from '@material-ui/icons';

import { formatAsDollars, percentage } from '../../../lib/helpers';
import styles from './styles';

export interface Props {
  classes: any;
  data: any[];
}

export const RentTrendText = (props: Props) => {
  const lastMonth = props.data[props.data.length - 1];
  const rentThisYear = formatAsDollars(lastMonth.rentTrend);
  const rentChange =
    (lastMonth.rentTrend - props.data[0].rentTrend) / props.data[0].rentTrend;
  const rentChangePerc = percentage(rentChange);
  const rentVerb = rentChange >= 0 ? 'increase' : 'decrease';

  if (!rentChange) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', margin: '7.5px 0' }}>
      {rentChange >= 0 && <TrendingUp htmlColor="#195A50" />}
      {rentChange < 0 && <TrendingDown htmlColor="#E2658C" />}
      <Typography className={props.classes.trendsText}>
        <strong>{rentChangePerc}</strong> {rentVerb} in rent from last year to
        <strong> {rentThisYear}</strong>
      </Typography>
    </div>
  );
};

export default withStyles(styles)(RentTrendText);
